import { useContext, useState } from 'react';
import {
     TablePagination, Typography, List, ListItem, ListItemButton, Grid, ListItemText, IconButton, Collapse, Button
} from '@mui/material';
import { ticketsContext } from '../TicketsContext';
import { SimecUser } from 'components';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { applicationContext, appUserContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { localeContext } from 'helpers/Locale/LocaleManager';
import {
    MdExpandLess as ExpandLess,
    MdExpandMore as ExpandMore,
    MdDelete as DeleteIcon
} from 'react-icons/md';

let MobileResults = () => {
    let { formatMessage } = useIntl();

    let history = useHistory();

    let { currentUser } = useContext(appUserContext);
    let { getCategoryById, getSubCategoryById } = useContext(applicationContext);
    let { currentLocale } = useContext(localeContext);

    let service = useContext(ticketsContext);
    let [openItem, setOpenItem] = useState<string | null>(null);


    return <>
        <List>
            {service.tickets.map((ticket, index) =>
                <React.Fragment key={index}>
                    <ListItemButton
                        disableGutters
                        divider={openItem !== ticket.ticketId}
                        onClick={() => { history.push(`/ticket/edit/${ticket.number}`); }}
                    >
                        <ListItemText
                            primary={`${ticket.number} - ${ticket.title}`}
                            secondary={ticket.customerName}
                        />
                        <IconButton
                            onClick={(event: any) => {
                                event.stopPropagation();
                                if (openItem === ticket.ticketId) {
                                    setOpenItem(null);
                                } else {
                                    setOpenItem(ticket.ticketId);
                                }
                            }}
                            size="large">
                            {openItem === ticket.ticketId
                                ? <ExpandLess size={24} />
                                : <ExpandMore size={24} />
                            }
                        </IconButton>
                    </ListItemButton>
                    <Collapse in={(openItem === ticket.ticketId)} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem divider onClick={() => { history.push(`/ticket/edit/${ticket.number}`); }}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Category })}:</b></Typography>
                                        <div style={{ color: getCategoryById(ticket.categoryId)?.color ?? undefined }}>
                                            {`${getCategoryById(ticket.categoryId)?.name[currentLocale]} / ${getSubCategoryById(ticket.ticketSubCategoryId)?.names[currentLocale]}`}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Priority })}:</b></Typography>
                                        {ticket.ticketPriority}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Status })}:</b></Typography>
                                        {ticket.ticketStatus[currentLocale]}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.AssignedTo })}:</b></Typography>
                                        <SimecUser username={ticket.assigneeUserName} defaultValue={formatMessage({ id: LocalizationIds.NotAssigned })} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2"><b>{formatMessage({ id: LocalizationIds.Orders })}:</b></Typography>
                                        {ticket.ordersCount > 0 &&
                                            <>
                                                {ticket.orders.map((x, index) =>
                                                    <React.Fragment key={index}>
                                                        Ordine&nbsp;{x.orderType}{x.orderNumber}&nbsp;{x.orderTitle}{index < ticket.orders.length - 1 ? <br /> : ''}
                                                    </React.Fragment>
                                                )}
                                                {ticket.ordersCount > 2 && ' ... +altri'}
                                            </>
                                        }
                                        {ticket.workOrdersCount > 0 &&
                                            <>
                                                {ticket.workOrders.map((x, index) =>
                                                    <React.Fragment key={index}>
                                                        <b>{x.workOrderNumber}</b>&nbsp;{x.articleId}&nbsp;{x.articleModel}&nbsp;{x.articleVersion}&nbsp;{x.articleDescription}{index < ticket.workOrders.length - 1 ? <br /> : ''}
                                                    </React.Fragment>
                                                )}
                                                {ticket.workOrdersCount > 2 && ` ... +${formatMessage({ id: LocalizationIds.Others }).toLowerCase()}`}
                                            </>
                                        }
                                    </Grid>
                                    {currentUser.simecClaims.canDeleteTicket &&
                                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button color="secondary" onClick={(e: any) => {
                                                e.stopPropagation();
                                                service.deleteTicket(ticket.ticketId);
                                            }}>
                                                <DeleteIcon /> {formatMessage({ id: LocalizationIds.Delete })}
                                            </Button>
                                        </Grid>
                                    }
                                </Grid>
                            </ListItem>
                        </List>
                    </Collapse>
                </React.Fragment>
            )}
            {service.isLoading === false && service.tickets.length === 0 &&
                <ListItem>
                    <ListItemText primary={formatMessage({ id: LocalizationIds.NoDataFound })} />
                </ListItem>
            }
        </List>
        <TablePagination
            component="div"
            count={service.recordCount}
            onPageChange={service.handleChangePage}
            page={service.search.pageNr}
            rowsPerPage={service.search.pageSize}
            rowsPerPageOptions={[service.search.pageSize]}
            labelDisplayedRows={({ page, count }) =>
                <>
                    {formatMessage({ id: LocalizationIds.TotalTickets })}:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                    {formatMessage(
                        { id: LocalizationIds.PageOf },
                        { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                    )}
                </>
            }
        />
    </>;
}

export default MobileResults;